module.exports = __webpack_public_path__ + "static/anishaJr-df71df96361d97adf7dccfe51ab3b62d.jpeg";